export const optionsBranch = [
  { value: 1, label: "วิศวกรรมอุตสาหการ" },
  { value: 2, label: "วิศวกรรมเคมี" },
  { value: 3, label: "วิศวกรรมโยธา" },
  { value: 4, label: "วิศวกรรมไฟฟ้า" },
  { value: 5, label: "วิศวกรรมเครื่องกล" },
  { value: 6, label: "วิศวกรรมสิ่งแวดล้อม" },
  { value: 7, label: "วิศวกรรมระบบสมองกลฝังตัวฯ" },
  { value: 8, label: "วิศวกรรมวัสดุ" },
];
